const shortMap = {
  h: 'height',
  w: 'width',
  maxW: 'maxWidth',
  maxH: 'maxHeight',

  p: 'padding',
  pt: 'paddingTop',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  pr: 'paddingRight',
  px: 'paddingLeft paddingRight',
  py: 'paddingTop paddingBottom',

  m: 'margin',
  mt: 'marginTop',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mr: 'marginRight',
  mx: 'marginLeft marginRight',
  my: 'marginTop marginBottom',

  z: 'zIndex',

  bg: 'backgroundColor',

  duration: 'transitionDuration',
};

function getStringsNumbers({
  strings,
  numbers,
  rest,
}: {
  strings: string[];
  numbers: string[];
  rest: any;
}) {
  const stringNumberStyle = {};

  strings.forEach((key) => {
    (shortMap[key] || key).split(' ').forEach((k) => {
      stringNumberStyle[k] = rest[key];
    });
  });
  numbers.forEach((key) => {
    if (key === 'z') {
      stringNumberStyle[shortMap[key] || key] = `${rest[key]}`;
    } else {
      (shortMap[key] || key).split(' ').forEach((k) => {
        stringNumberStyle[k] = `${rest[key] * 0.25}rem`;
      });
    }
  });

  return {
    stringNumberStyle,
  };
}

function isString(value: any) {
  return typeof value === 'string';
}

function isNumber(value: any) {
  return typeof value === 'number';
}

export { getStringsNumbers, isString, isNumber };
